module.exports = __webpack_public_path__ + "img/热泵及蓄热系统.243bdef9.png";